import * as React from 'react'
import { Alert } from '../Alert'
import { AlertTitle } from '../AlertTitle'
import { Link } from '../Link'

import { SnackbarContent, CustomContentProps, useSnackbar } from 'notistack'

declare module 'notistack' {
  interface VariantOverrides {
    // removes the `default` variant
    default: false
    // adds `success` variant and specifies the
    // "extra" props it takes in options of `enqueueSnackbar`
    success: {
      title?: string
      actionName?: string
      actionHandler?: (params: any) => any
      preventCloseOnClick?: boolean
    }
  }
}

interface SnackbarProps extends CustomContentProps {
  variant: 'error' | 'info' | 'success' | 'warning'
  title?: string
  actionName?: string
  actionHandler?: (params?: any) => any
  preventCloseOnAction?: boolean
}

export const Snackbar = React.forwardRef<HTMLDivElement, SnackbarProps>(
  (props, ref) => {
    const {
      id,
      title,
      message,
      actionName,
      preventCloseOnAction = false,
      actionHandler,
      variant,
      ...other
    } = props
    const { closeSnackbar } = useSnackbar()

    return (
      <SnackbarContent key={id} ref={ref} role="alert" {...other}>
        <Alert
          severity={variant ?? 'info'}
          variant="outlined"
          sx={{ width: 100 }}
          onClose={() => closeSnackbar(id)}
        >
          {title ? <AlertTitle>{title}</AlertTitle> : null}
          {message ? message : null}
          {actionName && typeof actionHandler === 'function' ? (
            <Link
              Component="button"
              color="primary"
              sx={{ display: 'flex', mt: 8, textWeight: 'demi' }}
              onClick={() => {
                actionHandler()
                if (!preventCloseOnAction) {
                  closeSnackbar(id)
                }
              }}
            >
              {actionName}
            </Link>
          ) : null}
        </Alert>
      </SnackbarContent>
    )
  }
)

Snackbar.displayName = 'Snackbar'
